module.exports = __webpack_public_path__ + "static/media/footer_1.9051df04.png";